// extracted by mini-css-extract-plugin
export default {"container":"for_4EYE2","item":"for_ite_1H5ON","label":"for_lab_3sHSk","answer":"for_ans_1EJax"};